<i class="online fa fa-user user-icon"
    ng-if="!vm.imageExits || !vm.profileImageStateReference.showImage">
</i>

<i ng-if="vm.imageExits && vm.profileImageStateReference.showImage" class="online fa user-icon new-profile-image" id="profileImage">
    <img ng-src="{{'data:image/' + vm.remoteData.format + ';base64,' + vm.remoteData.image}}" alt="Profile Picture">
</i>
